import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";

export const useMyAdsFeedStore = defineSmartFeedPiniaStore(
  "my-ads-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        publicationId: {
          key: "publication_id",
          payload: useCreatorPublicationStore().publicationId,
        },
      },
    }),
    getters: {
      feedUrl() {
        return `/publication/${useCreatorPublicationStore().publicationId}/ads`;
      },
    },
  },
);
